export enum ResponseCodeEnum {
  VERY_POSITIVE = 'VERY_POSITIVE',
  POSITIVE = 'POSITIVE',
  NEUTRAL = 'NEUTRAL',
  NEGATIVE = 'NEGATIVE',
  VERY_NEGATIVE = 'VERY_NEGATIVE',
  TOO_TECHNICAL_REPLIES = 'TOO_TECHNICAL_REPLIES',
  INCOMPLETE_ANSWER = 'INCOMPLETE_ANSWER',
  NOT_RELATED_TO_MY_PROBLEM = 'NOT_RELATED_TO_MY_PROBLEM',
  INCORRECT_LINKS = 'INCORRECT_LINKS',
  OTHER = 'OTHER',
}
